import React from 'react';
import slider1 from '../Slider/slider1.jpg'
import slider2 from '../Slider/slider2.jpg'
import slider3 from '../Slider/slider3.jpg'
import next1 from '../img/next1.jpg'
import next2 from '../img/next2.jpg'
import CustomLink from '../CustomLink/CustomLink';
const Home = () => {
    return (
        <div>
            <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div class="carousel-inner" style={{ height: '560px' }}>
                    <div class="carousel-item active">
                        <img src={slider1} class="d-block w-100" alt="..." />
                    </div>
                    <div class="carousel-item">
                        <img src={slider2} class="d-block w-100" alt="..." />

                    </div>
                    <div class="carousel-item">
                        <img src={slider3} class="d-block w-100" alt="..." />

                    </div>

                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>

            <br />
            {/* Services-section */}
            <section className='services'>
                <div className="row p-5 justify-content-center">
                    <h2>MY SERVICES</h2>
                    <div className="col-md-4 mb-1">
                        <div class="shadow p-2 mb-0 bg-body rounded">
                            <img className='w-100' src={slider1} alt="" />
                            <h5 className='mt-3'>Trip: Dhaka to Sajek (2-days)</h5>
                            <p>Price: 6000</p>
                            <CustomLink to={'/checkout'}>
                                <button className='btn btn-success mb-2'>Checkout</button>
                            </CustomLink >

                        </div>
                    </div>

                    <div className="col-md-4 mb-1">
                        <div class="shadow p-2 mb-0 bg-body rounded">
                            <img className='w-100' src={slider2} alt="" />
                            <h5 className='mt-3'>Trip: Dhaka to Bandarban (2-days) </h5>
                            <p>Price: 5000</p>
                            <CustomLink to={'/checkout'}>
                                <button className='btn btn-success mb-2'>Checkout</button>
                            </CustomLink >
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div class="shadow p-2 mb-0 bg-body rounded">
                            <img className='w-100' src={slider3} alt="" />
                            <h5 className='mt-3'>Trip: Dhaka to Rangamati(3-days)</h5>
                            <p>Price: 6000</p>
                            <CustomLink to={'/checkout'}>
                                <button className='btn btn-success mb-2'>Checkout</button>
                            </CustomLink >
                        </div>
                    </div>
                </div>
            </section>

            {/* Services-section */}


            <section className='Travels'>

                <div className="row p-5">

                    <div className="col-md-6">
                        <h4>MY PREVIOUS TRAVELS</h4>
                        <div class="shadow p-2 mb-5 bg-body rounded">
                            <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src={slider1} class="d-block w-100" alt="..." />
                                    </div>
                                    <div class="carousel-item">
                                        <img src={slider2} class="d-block w-100" alt="..." />
                                    </div>
                                    <div class="carousel-item">
                                        <img src={slider3} class="d-block w-100" alt="..." />
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-6">
                        <h4>MY NEXT TRAVELS</h4>
                        <div class="shadow p-2 mb-5 bg-body rounded">
                            <div id="carouselExampleControl" class="carousel slide" data-bs-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <img src={next1} class="d-block w-100" alt="..." />
                                    </div>
                                    <div class="carousel-item">
                                        <img src={next2} class="d-block w-100" alt="..." />
                                    </div>
                                    <div class="carousel-item">
                                        <img src={slider3} class="d-block w-100" alt="..." />
                                    </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControl" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControl" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

            </section>


            {/* footer section */}
            <section className='footer'>
                <div className="row bg-dark justify-content-center" style={{ height: '70px' }}>
                    <h6 className='text-white mt-4'>© 2022 Discovery Bangladesh</h6>
                </div>
            </section>
            {/* footer section */}

        </div>
    );
};

export default Home;